export default __webpack_public_path__ + "static/media/landing3.5671e505.png";